// extracted by mini-css-extract-plugin
module.exports = {"display":"style_display__3Vo8k","title":"style_title__3SHL5","body":"style_body__FfJsE","button":"style_button__bRAgs"};